module.exports = __webpack_public_path__ + "img/cartillas-silabas-inversas.706795f7.png";